import { Navigate, Route, Routes } from "react-router-dom";
import { Question, User } from "./components";
import { useAppSelector } from "store";
import { USER_ADMIN } from "commons/constants";

export const Admin = () => {
	const user = useAppSelector((state) => state.user);

	return (
		<Routes>
			<Route path="users" element={<User />} />
			{USER_ADMIN.includes(user?.id as string) && <Route path="questions" element={<Question />} />}
			<Route path="/" element={<Navigate to={"users"} replace />} />
		</Routes>
	);
};
